(function () {
  'use strict';

  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100);
  const api = async (path, options) => {
    const response = await fetch(root + path, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, options || {}));
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  };
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };

  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!expanded));
      menuButton.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
      mobileMenu.hidden = expanded;
    });
    mobileMenu.addEventListener('click', e => {
      if (e.target.closest('a')) {
        mobileMenu.hidden = true;
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open menu');
      }
    });
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  let focusBeforeDrawer = null;
  const closeCart = () => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    backdrop.hidden = true;
    document.body.style.overflow = '';
    if (focusBeforeDrawer && document.contains(focusBeforeDrawer)) focusBeforeDrawer.focus();
  };
  const openCart = async () => {
    if (!drawer) return;
    focusBeforeDrawer = document.activeElement;
    backdrop.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]').focus();
    await refreshCart();
  };
  document.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
  backdrop?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeCart(); return; }
    if (e.key !== 'Tab') return;
    const targets = Array.from(drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')).filter(node => node.offsetParent !== null);
    if (!targets.length) return;
    const first = targets[0], last = targets[targets.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  const setCartError = message => {
    const body = drawer?.querySelector('[data-cart-body]');
    if (!body) return;
    let error = body.querySelector('.cart-error');
    if (!error) { error = element('p', 'cart-error'); error.setAttribute('role', 'alert'); body.prepend(error); }
    error.textContent = message;
  };
  const refreshCart = async () => {
    if (!drawer) return;
    try {
      const cart = await api('cart.js');
      document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count || '');
      const body = drawer.querySelector('[data-cart-body]');
      const foot = drawer.querySelector('[data-cart-foot]');
      body.replaceChildren();
      foot.hidden = cart.item_count === 0;
      if (!cart.item_count) {
        const empty = element('div', 'cart-empty');
        empty.append(element('h3', '', drawer.dataset.emptyTitle), element('p', '', drawer.dataset.emptyDescription));
        const link = element('a', 'button button-dark', drawer.dataset.emptyButton);
        link.href = drawer.dataset.productUrl;
        empty.append(link);
        body.append(empty);
        return;
      }
      cart.items.forEach(item => {
        const line = element('div', 'cart-line');
        if (item.image) { const image = element('img'); image.src = item.image; image.alt = item.product_title || drawer.dataset.itemFallback; image.width = 82; image.height = 82; line.append(image); }
        else line.append(element('span'));
        const details = element('div');
        details.append(element('strong', '', item.product_title || drawer.dataset.itemFallback));
        const plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
        const variantLabel = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '';
        if (plan) details.append(element('p', '', item.quantity + (item.quantity === 1 ? ' bag' : ' bags') + ' · every ' + plan.name.toLowerCase().split('every ').pop()));
        else {
          if (variantLabel) details.append(element('p', '', variantLabel.slice(0, -3)));
          const stepper = element('div', 'qty-stepper');
          [-1, 1].forEach(step => {
            const button = element('button', '', step < 0 ? '−' : '+'); button.type = 'button';
            button.setAttribute('aria-label', step < 0 ? 'Fewer bags' : 'More bags');
            button.disabled = step < 0 && item.quantity === 1;
            button.addEventListener('click', async () => {
              stepper.querySelectorAll('button').forEach(node => node.disabled = true);
              try { await api('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: item.quantity + step }) }); await refreshCart(); }
              catch (error) { setCartError(error.message); refreshCart(); }
            });
            stepper.append(button);
          });
          const value = element('output', '', String(item.quantity)); value.setAttribute('aria-label', drawer.dataset.quantityLabel + ' ' + item.quantity);
          stepper.insertBefore(value, stepper.lastChild);
          details.append(stepper);
        }
        const remove = element('button', 'cart-remove', drawer.dataset.removeLabel); remove.type = 'button';
        remove.addEventListener('click', async () => {
          remove.disabled = true;
          try { await api('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) }); await refreshCart(); }
          catch (error) { setCartError(error.message); remove.disabled = false; }
        });
        details.append(remove);
        line.append(details, element('strong', '', money(item.final_line_price, cart.currency)));
        body.append(line);
      });
      const upgradeData = document.getElementById('cart-upgrade-data');
      const line = cart.items.length === 1 ? cart.items[0] : null;
      const oneTimeBag = line && !line.selling_plan_allocation && String(line.variant_id) === upgradeData?.dataset.singleProductId;
      const oneBagSubscription = line && line.quantity === 1 && (upgradeData?.dataset.bagPlanIds || '').split(',').includes(String(line.selling_plan_allocation?.selling_plan?.id));
      const targetPlanId = oneTimeBag ? upgradeData?.dataset.bagPlanId : oneBagSubscription ? upgradeData?.dataset.boxPlanId : '';
      if (targetPlanId && (oneTimeBag || oneBagSubscription)) {
        const box = element('div', 'cart-upgrade-box');
        const copy = drawer.dataset;
        box.append(element('h3', '', oneTimeBag ? copy.upgradeTitle : copy.boxUpgradeTitle), element('p', '', oneTimeBag ? copy.upgradeDescription : copy.boxUpgradeDescription));
        const button = element('button', 'button button-dark cart-upgrade', oneTimeBag ? copy.upgradeButton : copy.boxUpgradeButton); button.type = 'button';
        button.addEventListener('click', async () => {
          button.disabled = true;
          try {
            await api('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(upgradeData.dataset.productId), quantity: oneTimeBag ? line.quantity : Number(upgradeData.dataset.quantity), selling_plan: Number(targetPlanId), properties: { Bags: String(oneTimeBag ? line.quantity : Number(upgradeData.dataset.quantity)) } }) });
            await api('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
            await refreshCart();
          } catch (error) { setCartError(error.message); button.disabled = false; }
        });
        box.append(button); body.append(box);
      }
      const discounts = {};
      (cart.cart_level_discount_applications || []).forEach(discount => { discounts[discount.title] = (discounts[discount.title] || 0) + discount.total_allocated_amount; });
      cart.items.forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => { const title = allocation.discount_application.title; discounts[title] = (discounts[title] || 0) + allocation.amount; }));
      drawer.querySelector('[data-cart-discounts]').replaceChildren(...Object.entries(discounts).filter(([, amount]) => amount > 0).map(([title, amount]) => {
        const row = element('div', 'drawer-subtotal drawer-discount');
        row.append(element('span', '', title), element('span', '', '-' + money(amount, cart.currency)));
        return row;
      }));
      drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price, cart.currency);
      drawer.querySelector('[data-cart-checkout]').textContent = drawer.dataset.checkoutLabel + ' · ' + money(cart.total_price, cart.currency);
    } catch (error) { setCartError(error.message); }
  };
  refreshCart();

  window.WildGoatCart = { open: openCart };
})();
